/**
 * CPF do paciente guardado na ficha "atestados-medicos" com o atestado de
 * afastamento DESMARCADO.
 *
 * Com a opção desmarcada o campo fica oculto e não vai para documento nenhum,
 * mas o valor continua salvo (o preenchimento pelo cadastro nunca sobrescreve
 * um valor existente). Ao concluir a finalização, o backend
 * (`simpleFinishAttendance`/`simpleFinishPreAttendance`) grava o `cpfPaciente`
 * da ficha no cadastro do paciente sempre que ele existir — então um CPF velho
 * desse campo oculto sobrescrevia o CPF já corrigido no cadastro (caso Cleusa).
 *
 * Regra: com o atestado desmarcado, o CPF da ficha não deve ir para o
 * cadastro. Esta função devolve a ficha com `cpfPaciente: null` (o backend só
 * grava quando o valor existe) ou `null` quando não há nada a limpar.
 */
export function clearHiddenPatientCpf(
  value: Record<string, unknown> | null | undefined
): Record<string, unknown> | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null
  if (value.atestado === true) return null
  // String vazia também sai: o backend usa `isset`, e '' apagaria o CPF do
  // cadastro.
  if (value.cpfPaciente === null || value.cpfPaciente === undefined) return null
  return { ...value, cpfPaciente: null }
}
